import { render, staticRenderFns } from "./ChatbotFaqDetail.vue?vue&type=template&id=b4e0b29c&scoped=true"
import script from "./ChatbotFaqDetail.vue?vue&type=script&lang=js"
export * from "./ChatbotFaqDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatbotFaqDetail.vue?vue&type=style&index=0&id=b4e0b29c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e0b29c",
  null
  
)

export default component.exports